import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PasswordGenerator } from "@/features/vault/components/password-generator";
import { useI18n } from "@/providers/i18n-provider";

function GeneratorPage() {
  const { t } = useI18n();
  return (
    <div class="mx-auto w-full max-w-xl px-4 py-6">
      <h1 class="mb-1 text-xl font-semibold">{t(msg`Password generator`)}</h1>
      <p class="mb-6 text-sm text-muted-foreground">
        {t(msg`Create strong, unique passwords and passphrases.`)}
      </p>
      <PasswordGenerator />
    </div>
  );
}

export const generatorRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/generator",
  component: GeneratorPage,
});
